import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiPlay, FiUsers, FiActivity } from 'react-icons/fi';

const Step = ({ number, title, description, icon: Icon, delay }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay }}
    className="bg-white rounded-2xl p-6 shadow-soft border border-dc-teal-deep/5 relative"
  >
    <div className="absolute -top-3 -left-3 w-10 h-10 bg-dc-teal-deep rounded-full flex items-center justify-center text-white font-display font-bold text-sm">
      {number}
    </div>
    <div className="flex items-center gap-3 mb-3 mt-2">
      <div className="w-10 h-10 bg-dc-teal-signal/10 rounded-lg flex items-center justify-center">
        <SafeIcon icon={Icon} className="w-5 h-5 text-dc-teal-signal" />
      </div>
      <h3 className="text-lg font-semibold text-dc-teal-deep">{title}</h3>
    </div>
    <p className="text-dc-text/70 text-sm leading-relaxed">{description}</p>
  </motion.div>
);

const FromBriefingToPartnership = () => {
  return (
    <section className="py-16 px-6 max-w-5xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-center mb-12"
      >
        <h2 className="text-2xl md:text-3xl font-bold text-dc-teal-deep mb-4">
          From Briefing To Partnership
        </h2>
        <p className="text-lg text-dc-text/80 max-w-3xl mx-auto">
          Information becomes more powerful when the right people build with it.
        </p>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-6 mb-12">
        <Step 
          number="1"
          title="Hear the breakdown"
          description="Start with the AI Mastermind recording, speaker takeaways, and strategic breakdown."
          icon={FiPlay}
          delay={0}
        />
        <Step 
          number="2"
          title="Step into the rooms"
          description="Use AI Industry Strategy Rooms and the WhatsApp Community to connect with people who share your context."
          icon={FiUsers}
          delay={0.1}
        />
        <Step 
          number="3"
          title="Keep conversations alive"
          description="Use custom Territory channels so ideas, offers, and introductions have somewhere to take shape."
          icon={FiActivity}
          delay={0.2}
        />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.3 }}
        className="bg-gradient-to-r from-dc-teal-deep/5 to-dc-gold-1/5 rounded-2xl p-8 text-center border border-dc-teal-deep/10"
      >
        <p className="text-dc-teal-deep font-medium text-base leading-relaxed">
          Your words don't disappear after the meeting. They become introductions, channels, and momentum.
        </p>
      </motion.div>
    </section>
  );
};

export default FromBriefingToPartnership;